<template>
  <div class="text-white" id="strategy-session">
    <div class="carousel-overlay bg-transparent-gradient-inverse" />
    <div class="container py-5">
      <div class="row">
        <div class="col-md-6 offset-md-6">
          <h2 class="display-4">Book a strategy session</h2>
          <h5>Get educated on the following:</h5>
          <ul>
            <li>Market climate</li>
            <li>Purchasing and selling</li>
            <li>Fine tuning your portfolio</li>
            <li>Purchasing your next property</li>
            <li>Landlord insurance</li>
            <li>Depreciation schedule</li>
            <li>Cash flow management</li>
            <li>Forecasting and planning</li>
          </ul>
          <p style="clear: both;">
            <a class="ml-4 btn btn-outline-light" href="#" @click="scrollTo('contact')">Book Now</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#strategy-session {
  position: relative;
  background-image: url("../assets/strategy-session.jpg");
  background-size: cover;
  height: 700px;
  .container {
    position: relative;
    z-index: 9;
    top: 120px;
  }
}
</style>

<script>
import $ from "jquery";

export default {
  methods: {
    scrollTo(element) {
      let scrollPoint = $("#" + element).offset().top - 150;
      if (scrollPoint < 0) scrollPoint = 0;
      $("html, body").animate(
        {
          scrollTop: scrollPoint
        },
        2000
      );
    }
  }
};
</script>
